(function(){
"use strict";
var D=document, $=function(id){return D.getElementById(id)};
var DATA={}; try{ DATA=JSON.parse(($('sf-data')||{}).textContent||"{}") }catch(e){}
var FAMS=DATA.families||[], OFF=DATA.addon_discount||0.10, FREE=DATA.free_delivery_threshold||20000;

/* MONEY SCALE
   Shopify reports money in hundredths wherever it is generated server side:
   Liquid product.price and the cart.js payload both return 2500 for a 25 KD
   frame. The products.json feed returns "25.000", which the loaders turn
   into 25000. Everything here works on that x1000 scale. */
var money=function(c){return (c/1000).toFixed(3)+" KD"};
var sc=function(v){return (v||0)*10};

function tint(name,fallback){return (typeof window.SFTint==='function')?window.SFTint(name,fallback):(fallback||'#9bd1cc')}
function rangeOf(b){ return (typeof window.SFBundleRange==='function') ? window.SFBundleRange(b) : (b&&b.range)||'' }
var CATS=["Sunglasses","Optical","Blue Light","Kids","Limited drops"];
var SHAPES=["Square","Round","Cat-eye","Pilot","Rectangle","Oval","Hexagon"];
var MATERIALS=["Acetate","Metal","Titanium","Polycarbonate","Carbon fibre","Acetate and metal","Wood"];
var TECHS=["Full rim","Half rim","Rimless"];
var FCOL=[["Black","#1c1c1c"],["Brown","#6b4a30"],["Tortoise","#8a5a2b"],["Blue","#3a5a7d"],["Green","#4c6b4f"],
["Grey","#8b8f92"],["Silver","#c9ccce"],["Gold","#b39a63"],["Red","#9c3b32"],["Pink","#e59ab4"],["Yellow","#e3c74a"],["Clear","#dfe3e4"]];
var LCOL=[["Black","#1c1c1c"],["Brown","#6b4a30"],["Green","#3f5c46"],["Blue","#3a5a7d"],["Grey","#8b8f92"],
["Yellow","#e3c74a"],["Pink","#e59ab4"],["Red","#9c3b32"],["Clear","#eef1f2"]];
var TILES=["#f1f6fc","#e1d5ef","#f9e7d2","#fafe95","#f0f8f7","#fdeef2","#eef3ea","#f4f0e6"];
var SORTS=["Featured","Best selling","Price, low to high","Price, high to low"];
var TICK='<svg viewBox="0 0 24 24"><path d="m5 13 4 4L19 7"/></svg>';
function toast(t){var e=$('toast'); if(!e)return; e.textContent=t; e.classList.add('on');
clearTimeout(e._t); e._t=setTimeout(function(){e.classList.remove('on')},2400)}
function rgb(h){h=(h||'#888888').replace('#',''); if(h.length===3)h=h[0]+h[0]+h[1]+h[1]+h[2]+h[2];
return [parseInt(h.slice(0,2),16),parseInt(h.slice(2,4),16),parseInt(h.slice(4,6),16)]}
function cd(a,b){var x=rgb(a),y=rgb(b);return Math.abs(x[0]-y[0])+Math.abs(x[1]-y[1])+Math.abs(x[2]-y[2])}
function famBy(h){for(var i=0;i<FAMS.length;i++)if(FAMS[i].handle===h)return FAMS[i];return null}
function closeAll(){['bag','filters','quick','menu'].forEach(function(i){var e=$(i);if(e)e.classList.remove('on')});
var s=$('scrim'); if(s)s.classList.remove('on')}
function open_(id){var s=$('scrim'); if(s)s.classList.add('on'); var e=$(id); if(e)e.classList.add('on')}
function openMenu(){open_('menu')}
function syncCount(n){[['cc',n],['tabCount',n]].forEach(function(p){var e=$(p[0]); if(!e)return;
e.textContent=p[1]; if(p[1])e.removeAttribute('hidden'); else e.setAttribute('hidden','')})}
function cartJSON(){return fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json()})}
/* ---- ADDING HAS TO BE ABLE TO FAIL ----
   This used to throw the response away and always resolve. Shopify answers
   a rejected /cart/add.js with 422 and a description — sold out, a variant
   that is not published, a quantity it will not allow — and none of that
   reached the shopper. The bundle builder then cleared the picks and said
   "2 for 40 KD added" over a cart that had not changed, which is the worst
   possible combination: the page claims the sale and destroys the evidence
   of what was being bought.

   It now rejects with Shopify's own words, and every caller decides what to
   do with that. The bag is re-rendered either way, so the drawer always
   shows what is actually in the cart rather than what we hoped was. */
function addItems(items){
return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items})})
.then(function(r){
  return r.json().catch(function(){ return {} }).then(function(j){ return {ok:r.ok, body:j} });
})
.then(function(res){
  return renderBag().then(function(){
    if(!res.ok){
      var msg=(res.body && (res.body.description || res.body.message)) || 'Could not add to bag';
      throw new Error(msg);
    }
    return res.body;
  });
})
}
/* ---- WHERE A SHOPPER IS SENT AFTER ADDING ----
   Everywhere on the site, adding opens the bag: the shopper has finished
   choosing and the drawer is the next step, with the add-on row and the
   delivery meter in it.

   THE BUNDLE BUILDER SPLITS THAT IN TWO, because two different things
   happen there. Adding ONE frame — from the bag's add-on row — is a step
   inside a longer task: the shopper is still picking, and a drawer sliding
   over the grid interrupts the job it just helped them do. Completing a
   BUNDLE is the end of the task, and there the drawer is exactly right: it
   shows the fixed price, what was saved, and the way to checkout.

   So the quiet behaviour belongs to addVariant only, and addBundle opens
   the bag like everywhere else.

   THE TEST IS THE BUILDER'S OWN GRID, not the URL: the page handle can be
   renamed in admin, #bGrid cannot appear anywhere else. */
function inBuilder(){ return !!$('bGrid') }
function addVariant(id,qty,props){
var it={id:id,quantity:qty||1}; if(props)it.properties=props;
return addItems([it]).then(function(){
if(inBuilder()){ toast('Added to bag') } else { openBag() }
}, function(err){
/* Resolved, not rejected: sf-addtobag reads a rejection as "SF is broken"
   and falls back to a full-page form post, which would replace the page
   with Shopify's error screen. The shopper is better served by the toast. */
toast(err && err.message ? err.message : 'Could not add to bag');
})
}
function changeLine(key,qty){
return fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},
body:JSON.stringify({id:key,quantity:qty})}).then(function(r){return r.json()}).then(function(){return renderBag()})
}
/* A bundle is several lines tied by _bundle_id. Removing one used to leave
   the others behind, still labelled as a bundle and waiting for a partner,
   so the shopper built another and kept the orphan too. Removing any line
   of a bundle removes the whole bundle. */
function removeBundle(gid){
return cartJSON().then(function(c){
var updates={};
(c.items||[]).forEach(function(l){
var g=l.properties && l.properties._bundle_id;
if(g && String(g)===String(gid)) updates[l.key]=0;
});
if(!Object.keys(updates).length) return null;
return fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},
body:JSON.stringify({updates:updates})}).then(function(r){return r.json()});
}).then(function(){ toast('Bundle removed'); return renderBag() });
}
function openBag(){renderBag(); open_('bag')}
function renderBag(){
var b=$('bagBody'), f=$('bagFoot'); if(!b)return Promise.resolve();
return cartJSON().then(function(c){
syncCount(c.item_count);
if(!c.item_count){
b.innerHTML='<div class="empty"><h3>Your bag is empty</h3><p>Pick a shape and the colours follow.</p>'+
'<a class="btn out sm" href="/collections">Shop frames</a></div>'; f.innerHTML=''; return}
var sizes={};
c.items.forEach(function(l){
var g=l.properties && l.properties._bundle_id;
if(g) sizes[g]=(sizes[g]||0)+1;
});
b.innerHTML=c.items.map(function(l,i){
var gid=l.properties && l.properties._bundle_id;
var whole=gid && sizes[gid]>1;
var tag=l.properties&&l.properties._bundle
? '<span style="font-size:10px;display:block;margin-top:2px" class="uc">'+
  (whole ? l.properties._bundle : 'Bundle incomplete &middot; priced on its own')+'</span>'
:(l.properties&&l.properties._set?'<span style="font-size:10px;display:block;margin-top:2px" class="uc">Set item &middot; 10% off</span>':'');
var qty=gid
? '<span style="display:block;font-size:11px;color:var(--mute);margin-top:6px">'+
  (whole?'Part of a bundle of '+sizes[gid]:'Was part of a bundle')+'</span>'
: '<div class="qty"><button onclick="SF.qty(\''+l.key+'\','+(l.quantity-1)+')">&minus;</button>'+
'<span class="mono">'+l.quantity+'</span>'+
'<button onclick="SF.qty(\''+l.key+'\','+(l.quantity+1)+')">+</button></div>';
var rm = gid
? '<button class="rm" onclick="SF.removeBundle(\''+gid+'\')">'+(whole?'Remove bundle':'Remove')+'</button>'
: '<button class="rm" onclick="SF.qty(\''+l.key+'\',0)">Remove</button>';
var was = (l.original_line_price && l.original_line_price > l.final_line_price)
? ' <s class="mono" style="color:#b3b8b7">'+money(sc(l.original_line_price))+'</s>' : '';
return '<div class="bagline"><img src="'+(l.image||'')+'" alt="">'+
'<div style="flex:1"><b>'+l.product_title+'</b>'+
'<span class="mono">'+money(sc(l.final_line_price))+was+'</span>'+tag+qty+'</div>'+
rm+'</div>'
}).join('');
var total=sc(c.total_price), free=total>=FREE;
b.innerHTML+='<div class="meter">'+(free?'Free delivery unlocked':money(FREE-total)+' more for free delivery')+
'<div class="b"><i style="width:'+(free?100:Math.min(100,total/FREE*100))+'%"></i></div></div>';
/* Subtotal is the price BEFORE discounts. items_subtotal_price is already
   net of them, which printed as "Subtotal 50, Discounts -10, Total 50". */
f.innerHTML='<div class="tot"><div><span>Subtotal</span><span class="mono">'+money(sc(c.original_total_price))+'</span></div>'+
(c.total_discount?'<div><span>Discounts</span><span class="mono">&minus;'+money(sc(c.total_discount))+'</span></div>':'')+
'<div><span>Delivery</span><span class="mono">'+(free?'Free':'calculated at checkout')+'</span></div>'+
'<div class="big"><span>Total</span><span class="mono">'+money(total)+'</span></div></div>'+
'<div style="margin-top:12px"><a class="btn" style="display:block" href="/checkout">Checkout</a></div>';
})
}
function paint(card,dot){
var img=card.querySelector('.sh img'); if(img&&dot.dataset.img)img.src=dot.dataset.img;
var link=card.querySelector('.sh a'); if(link&&dot.dataset.url)link.href=dot.dataset.url;
var meta=card.querySelector('a.meta'); if(meta&&dot.dataset.url)meta.href=dot.dataset.url;
var dots=dot.parentNode.querySelectorAll('i');
for(var i=0;i<dots.length;i++)dots[i].setAttribute('aria-pressed', dots[i]===dot?'true':'false');
}
function swap(handle,el){var card=$('c-'+handle); if(!card)return; paint(card,el)}
function reflow(dd){
var dots=dd.querySelectorAll('i');
for(var i=0;i<dots.length;i++)dots[i].style.display = i<6 ? '' : 'none';
}
function words(s){return String(s||'').toLowerCase().split(/[^a-z]+/).filter(Boolean)}
function bestDot(cands, wanted){
  if(!cands.length) return null;
  if(!wanted.length) return cands[0];
  var i,j;
  for(j=0;j<wanted.length;j++){
    var w=wanted[j].toLowerCase();
    for(i=0;i<cands.length;i++) if(String(cands[i].dataset.name||'').toLowerCase()===w) return cands[i];
  }
  for(j=0;j<wanted.length;j++){
    var w2=wanted[j].toLowerCase();
    for(i=0;i<cands.length;i++) if(words(cands[i].dataset.name).indexOf(w2)>-1) return cands[i];
  }
  return cands[0];
}
function previewColour(w){
var card=w.querySelector('.card'); if(!card)return;
var dd=card.querySelector('.dd'); if(!dd)return;
var dots=dd.querySelectorAll('i'); if(!dots.length)return;
if(!dd.dataset.order){
for(var n=0;n<dots.length;n++){dots[n].dataset.idx=n;} dd.dataset.order='1';
}
var target=null;
if(filt.fcolour.length||filt.lcolour.length){
var cands=[];
for(var i=0;i<dots.length;i++){
var fcs=(dots[i].dataset.colour||'').split('+'), lc=dots[i].dataset.lens||'';
var okF=!filt.fcolour.length;
for(var q=0;q<fcs.length && !okF;q++) if(filt.fcolour.indexOf(fcs[q].trim())>-1) okF=true;
var okL=!filt.lcolour.length||filt.lcolour.indexOf(lc)>-1;
if(okF&&okL) cands.push(dots[i]);
}
target=bestDot(cands, filt.fcolour.length?filt.fcolour:filt.lcolour);
}
var list=Array.prototype.slice.call(dots);
list.sort(function(a,b){return (+a.dataset.idx)-(+b.dataset.idx)});
if(target){var k=list.indexOf(target); list.splice(k,1); list.unshift(target)}
for(var j=0;j<list.length;j++)dd.insertBefore(list[j], dd.querySelector('.more')||null);
reflow(dd);
paint(card, target||list[0]);
}
function gridCols(grid){
  var t=getComputedStyle(grid).gridTemplateColumns;
  var n=(t||'').split(' ').filter(function(s){return s.trim()}).length;
  return n>0?n:1;
}
function shuffleTints(grid, visible){
  var cols=gridCols(grid), row=[], i, k;
  for(i=0;i<visible.length;i++){
    if(i % cols === 0) row=[];
    var sh=visible[i].querySelector('.sh');
    if(!sh) continue;
    if(sh.dataset.fixed){ row.push((sh.style.background||'').trim()); continue }
    var pool=TILES.filter(function(c){ return row.indexOf(c)<0 });
    if(!pool.length) pool=TILES.slice();
    k=pool[Math.floor(Math.random()*pool.length)];
    sh.style.background=k;
    row.push(k);
  }
}
function quick(handle){
var f=famBy(handle); if(!f){window.location='/collections/'+handle; return}
$('qTitle').textContent=f.title;
var sel=0;
$('qBody').innerHTML='<div class="swrow" id="qSw" style="margin-top:16px">'+f.products.map(function(p,i){
return '<button aria-pressed="'+(i===0)+'" data-i="'+i+'"><img src="'+p.img+'" alt=""><em>'+
p.title.replace(f.title,'').trim()+'</em></button>'}).join('')+'</div>'+
'<p class="pmeta" id="qn">'+f.products[0].title+' &middot; '+money(f.products[0].price)+'</p>';
var btns=$('qSw').querySelectorAll('button');
Array.prototype.forEach.call(btns,function(b){b.onclick=function(){
sel=+b.dataset.i;
Array.prototype.forEach.call(btns,function(x){x.setAttribute('aria-pressed','false')});
b.setAttribute('aria-pressed','true');
$('qn').textContent=f.products[sel].title+' \u00b7 '+money(f.products[sel].price);
$('qView').href=f.products[sel].url}});
/* The builder borrows this drawer and hides the View link; put it back. */
var qv=$('qView');
qv.style.display='';
qv.href=f.products[0].url;
qv.textContent='Open the family';
var qa=$('qAdd');
qa.textContent='Add to bag';
qa.onclick=function(){addVariant(f.products[sel].id)};
open_('quick');
}
var filt={types:[],shape:[],fcolour:[],lcolour:[],mat:[],tech:[],min:0,max:10000};
var sortBy="Featured", sortOpen=false;
function nA(){return filt.types.length+filt.shape.length+filt.fcolour.length+filt.lcolour.length+
filt.mat.length+filt.tech.length+(filt.max<10000?1:0)+(filt.min>0?1:0)}
function wraps(){return Array.prototype.slice.call(D.querySelectorAll('#famGrid .fam-wrap'))}
function matches(w){
var d=w.dataset;
var isKid=(d.types||'').indexOf('Kids')>-1;
if(!filt.types.length&&isKid)return false;
if(filt.types.length&&!filt.types.some(function(t){return (d.types||'').indexOf(t)>-1}))return false;
if(filt.shape.length){
var mine=(d.shape||'').split('|'), hit=false;
for(var si=0;si<mine.length;si++){ if(filt.shape.indexOf(mine[si].trim())>-1){hit=true;break} }
if(!hit)return false;
}
if(filt.mat.length&&filt.mat.indexOf(d.material)<0)return false;
if(filt.tech.length&&!filt.tech.some(function(t){return (d.tech||'').indexOf(t)>-1}))return false;
if(filt.fcolour.length&&!filt.fcolour.some(function(c){return (d.fcolour||'').toLowerCase().indexOf(c.toLowerCase())>-1}))return false;
if(filt.lcolour.length&&!filt.lcolour.some(function(c){return (d.lens||'').toLowerCase().indexOf(c.toLowerCase())>-1}))return false;
if(+d.price>filt.max*1000)return false;
if(+d.price<filt.min*1000)return false;
return true}
function applySort(list){
var l=list.slice();
if(sortBy==="Price, low to high"){l.sort(function(a,b){return (+a.dataset.price)-(+b.dataset.price)}); return l}
if(sortBy==="Price, high to low"){l.sort(function(a,b){return (+b.dataset.price)-(+a.dataset.price)}); return l}
if(sortBy==="Best selling"){l.sort(function(a,b){return (+a.dataset.rank||9999)-(+b.dataset.rank||9999)}); return l}
l.sort(function(a,b){return (+a.dataset.order)-(+b.dataset.order)});
return l}
function renderShop(){
var grid=$('famGrid'); if(!grid)return;
var all=wraps(), shown=0, visible=[];
applySort(all).forEach(function(w){grid.appendChild(w);
var ok=matches(w); w.style.display=ok?'':'none'; if(ok){shown++; visible.push(w); previewColour(w)}});
shuffleTints(grid, visible);
var e=$('famEmpty'); if(e)e.style.display=shown?'none':'';
var c=$('famCount'); if(c)c.textContent=shown+(shown===1?' family':' families');
var fc=$('fCount'); if(fc)fc.textContent=nA()?' ('+nA()+')':'';
var sl=$('sortLbl'); if(sl)sl.textContent=sortBy;
var af=$('activeFilters');
if(af){var chips=[];
[['types','types'],['shape','shape'],['mat','mat'],['tech','tech']].forEach(function(k){
filt[k[0]].forEach(function(v){chips.push([k[0],v,v])})});
filt.fcolour.forEach(function(v){chips.push(['fcolour',v,v+' frame'])});
filt.lcolour.forEach(function(v){chips.push(['lcolour',v,v+' lens'])});
var extra=filt.min>0?'<button onclick="SF.setMin(0)">From '+filt.min+' KD <span style="opacity:.6">&#10005;</span></button>':'';
af.innerHTML=(chips.length||extra)?chips.map(function(c2){
return '<button onclick="SF.tog(\''+c2[0]+'\',\''+c2[1]+'\')">'+c2[2]+' <span style="opacity:.6">&#10005;</span></button>'}).join('')+extra+
'<button onclick="SF.clearFilters()" style="border-color:var(--line);color:var(--mute)">Clear all</button>':''}
var sm=$('sortmenu');
if(sm)sm.innerHTML=SORTS.map(function(v){return '<button role="option" aria-checked="'+(v===sortBy)+
'" onclick="SF.setSort(\''+v+'\')"><i>'+(v===sortBy?'&#10003;':'')+'</i>'+v+'</button>'}).join('');
}
function tog(k,v){var a=filt[k],i=a.indexOf(v); if(i>-1)a.splice(i,1); else a.push(v);
if($('filters')&&$('filters').classList.contains('on'))buildFilters(); renderShop()}
function setSort(v){sortBy=v; sortOpen=false; var m=$('sortmenu'); if(m)m.classList.remove('on'); renderShop()}
function toggleSort(){sortOpen=!sortOpen;var m=$('sortmenu');if(m){m.classList.toggle('on',sortOpen);
$('sortbtn').setAttribute('aria-expanded',String(sortOpen))}}
function chip(k,v,extra){return '<button class="chip" aria-pressed="'+(filt[k].indexOf(v)>-1)+
'" onclick="SF.tog(\''+k+'\',\''+v+'\')">'+(extra||'')+v+'</button>'}
function buildFilters(){
var b=$('fBody'); if(!b)return;
b.innerHTML=
'<div class="fgroup"><h4>Category</h4><div class="fopts">'+
CATS.map(function(v){return chip('types',v)}).join('')+'</div></div>'+
'<div class="fgroup"><h4>Shape</h4><div class="fopts">'+
SHAPES.map(function(v){return chip('shape',v)}).join('')+'</div></div>'+
'<div class="fgroup"><h4>Frame colour</h4><div class="cols">'+
FCOL.map(function(c){return '<button aria-pressed="'+(filt.fcolour.indexOf(c[0])>-1)+
'" onclick="SF.tog(\'fcolour\',\''+c[0]+'\')"><i style="background:'+c[1]+'"></i>'+c[0]+'</button>'}).join('')+'</div></div>'+
'<div class="fgroup"><h4>Lens colour</h4><div class="cols">'+
LCOL.map(function(c){return '<button aria-pressed="'+(filt.lcolour.indexOf(c[0])>-1)+
'" onclick="SF.tog(\'lcolour\',\''+c[0]+'\')"><i style="background:'+c[1]+'"></i>'+c[0]+'</button>'}).join('')+'</div></div>'+
'<div class="fgroup"><h4>Frame material</h4><div class="fopts">'+
MATERIALS.map(function(v){return chip('mat',v)}).join('')+'</div></div>'+
'<div class="fgroup"><h4>Rim style</h4><div class="fopts">'+
TECHS.map(function(v){return chip('tech',v)}).join('')+'</div></div>'+
'<div class="fgroup"><h4>Price up to <span class="mono" id="pv">'+(filt.max>=10000?'any':filt.max+'.000 KD')+'</span></h4>'+
'<div class="range"><span class="mono" style="font-size:11px">0</span>'+
'<input type="range" min="0" max="100" step="5" value="'+(filt.max>100?100:filt.max)+'" oninput="SF.setMax(this.value)">'+
'<span class="mono" style="font-size:11px">100</span></div></div>';
}
function setMax(v){filt.max=(+v>=100)?10000:+v; var p=$('pv');
if(p)p.textContent=filt.max>=10000?'any':filt.max+'.000 KD'; renderShop()}
function setMin(v){filt.min=+v||0; renderShop()}
function openFilters(){buildFilters();open_('filters');renderShop()}
function applyFilters(){closeAll();renderShop()}
function clearFilters(){filt={types:[],shape:[],fcolour:[],lcolour:[],mat:[],tech:[],min:0,max:10000};
if($('filters'))buildFilters(); renderShop()}
function fromURL(){
var q; try{ q=new URLSearchParams(window.location.search) }catch(e){ return }
var map={type:'types',shape:'shape',fcolour:'fcolour',lcolour:'lcolour',material:'mat',tech:'tech'};
Object.keys(map).forEach(function(k){
var v=q.getAll(k);
if(v.length){ filt[map[k]]=[]; v.forEach(function(one){
one.split(',').forEach(function(part){ part=part.trim(); if(part)filt[map[k]].push(part) }) }) }
});
if(q.get('min'))filt.min=+q.get('min')||0;
if(q.get('max'))filt.max=+q.get('max')||10000;
if(q.get('sort'))sortBy=q.get('sort');
}
var setState={tab:0,picked:{},fam:null,variant:null,hex:'#888888',isKid:false};
function objectsFrom(handle){
return fetch('/collections/'+handle+'/products.json?limit=50').then(function(r){return r.json()})
.then(function(j){return (j.products||[]).filter(function(p){
return p.variants && p.variants[0] && p.variants[0].available !== false })
.map(function(p){
return {id:p.variants[0].id,name:p.title,price:Math.round(parseFloat(p.variants[0].price)*1000),
img:(p.images[0]||{}).src||'',hex:tint(p.title,'#8a8f8e')}})}).catch(function(){return []})
}
var CAPS=[],ACCS=[];
function rank(pool,hex){return pool.slice().sort(function(a,b){return cd(a.hex,hex)-cd(b.hex,hex)}).slice(0,3)}
function partners(){
var f=setState.fam; if(!f)return [];
var out=[];
FAMS.forEach(function(x){
if(x.handle===f.handle)return;
if(x.shape!==f.shape)return;
var xKid=(''+x.types).toLowerCase().indexOf('kids')>-1;
if(setState.isKid?xKid:!xKid)return;
var best=x.products.slice().sort(function(a,b){
return cd(a.hex||tint(a.title),setState.hex)-cd(b.hex||tint(b.title),setState.hex)})[0];
if(best)out.push({id:best.id,name:x.title+' \u00b7 '+best.title.replace(x.title,'').trim(),price:best.price,
img:best.img,hex:best.hex||tint(best.title),kind:xKid?'kidframe':'adultframe',
note:xKid?'Same '+(x.shape||'').toLowerCase()+', kid sized':'Same '+(x.shape||'').toLowerCase()+', adult size'})
});
return out.slice(0,2)
}
function setTotals(){
var base=setState.price||0, ex=0, save=0, n=0, kidMain=false;
Object.keys(setState.picked).forEach(function(k){var it=setState.picked[k]; ex+=it.price; n++;
if(it.kind!=='adultframe')save+=it.price*OFF;
if(setState.isKid&&it.kind==='adultframe')kidMain=true});
if(kidMain)save+=base*OFF;
return {raw:base+ex,net:base+ex-save,save:save,n:n}}
function renderSet(){
var host=$('setmod'); if(!host)return;
var t=setTotals();
var list = setState.tab===0 ? rank(ACCS,setState.hex).map(function(o){return {id:o.id,name:o.name,price:o.price,img:o.img,hex:o.hex,kind:'acc',note:'Picks up this colour'}})
: setState.tab===1 ? partners()
: rank(CAPS,setState.hex).map(function(o){return {id:o.id,name:o.name,price:o.price,img:o.img,hex:o.hex,kind:'cap',note:'Picks up this colour'}});
var rows = list.length ? list.map(function(it){
var on=!!setState.picked[it.id], disc=it.kind!=='adultframe';
var safeName=String(it.name).split("'").join("&#39;");
var col=it.hex||tint(it.name,setState.hex);
return '<button class="arow" data-on="'+(on?1:0)+'" aria-pressed="'+on+'"'+
' style="border-color:'+(on?'#141a19':col)+';border-width:1.5px"'+
' onclick="SF.pick('+it.id+','+it.price+
',\''+it.kind+'\',\''+safeName+'\',\''+it.img+'\')">'+
'<img src="'+it.img+'" alt="" style="box-shadow:inset 0 0 0 2px '+col+'">'+
'<span class="m"><b>'+it.name+'</b><span>'+
'<i style="display:inline-block;width:8px;height:8px;border-radius:50%;background:'+col+
';margin-right:6px;vertical-align:middle;box-shadow:inset 0 0 0 1px rgba(0,0,0,.15)"></i>'+it.note+'</span></span>'+
'<span class="mono" style="font-size:12px;text-align:right">'+
(disc?money(Math.round(it.price*(1-OFF)))+'<br><s style="color:var(--mute);font-size:10.5px">'+money(it.price)+'</s>':money(it.price))+
'</span><span class="tick">'+TICK+'</span></button>'}).join('')
: '<div class="none">Nothing to pair here yet. <u onclick="location.href=\'/collections\'">Browse everything</u>.</div>';
host.innerHTML='<h2 class="h-sec uc">Make it a set</h2>'+
'<div class="tabs" role="tablist">'+
'<button class="tab" role="tab" aria-selected="'+(setState.tab===0)+'" onclick="SF.setTab(0)">Accessories</button>'+
'<button class="tab" role="tab" aria-selected="'+(setState.tab===1)+'" onclick="SF.setTab(1)">'+(setState.isKid?'Grown-up match':'Mini match')+'</button>'+
'<button class="tab" role="tab" aria-selected="'+(setState.tab===2)+'" onclick="SF.setTab(2)">Caps</button></div>'+
'<div class="rows">'+rows+'</div>'+
'<div class="setfoot"><span class="t">'+(t.n?'Set of '+(t.n+1):'Frame only')+
'<b class="mono">'+money(Math.round(t.net))+(t.save?'<s>'+money(t.raw)+'</s>':'')+'</b></span>'+
'<button class="btn" style="width:auto;padding:14px 24px" onclick="SF.addSet()">'+(t.n?'Add set':'Add frame')+'</button></div>'+
'<p class="note">Ten percent comes off caps, accessories and kids frames. The frame you came for stays at '+money(setState.price)+'.</p>';
}
function setTab(i){setState.tab=i;renderSet()}
function pick(id,price,kind,name,img){
if(setState.picked[id])delete setState.picked[id];
else setState.picked[id]={price:price,kind:kind,name:name,img:img};
renderSet()}
function addSet(){
var items=[{id:setState.variant,quantity:1}];
var kidMain=setState.isKid&&Object.keys(setState.picked).some(function(k){return setState.picked[k].kind==='adultframe'});
if(kidMain)items[0].properties={_set:'yes'};
Object.keys(setState.picked).forEach(function(k){var it=setState.picked[k];
var i={id:+k,quantity:1};
if(it.kind!=='adultframe')i.properties={_set:'yes'};
items.push(i)});
addItems(items).then(function(){openBag();
var t=setTotals(); toast(t.save?'Set added':'Added to bag')},
function(err){ toast(err && err.message ? err.message : 'Could not add to bag') })
}
function initPDP(){
var pdp=$('pdp'); if(!pdp)return;
var handle=pdp.dataset.family;
setState.fam=famBy(handle)||{title:'',products:[],shape:''};
setState.variant=+pdp.dataset.variant;
var mod=$('setmod');
var p=(setState.fam.products||[]).filter(function(x){return x.id===setState.variant})[0];
setState.price=p?p.price:0;
setState.hex=(p&&p.hex)||(p?tint(p.title,'#888888'):'#888888');
setState.isKid=(''+setState.fam.types).toLowerCase().indexOf('kids')>-1;
var capsH=(mod&&mod.dataset.caps)||'all-caps', accsH=(mod&&mod.dataset.accs)||'accessories';
Promise.all([objectsFrom(capsH),objectsFrom(accsH)]).then(function(r){CAPS=r[0];ACCS=r[1];renderSet()});
renderSet();
}
function gal(btn,src){var i=$('pimg'); if(i)i.src=src;
var sibs=btn.parentNode.querySelectorAll('button');
for(var k=0;k<sibs.length;k++)sibs[k].setAttribute('aria-pressed','false');
btn.setAttribute('aria-pressed','true')}

/* ---- Bundle builder ----
   ONE CARD PER FAMILY, THE SAME SHAPE AS THE FAMILIES GRID. The builder
   used to render a card per colourway, which meant Due Silver appeared
   eight times in a row: eight photographs of the same frame, eight names
   differing by one word, and a screen and a half of scrolling to get past
   one family. Grouping them in the sort put them next to each other but did
   not stop them being eight cards.

   A card is now a family: its photo, its name, and a dot for every
   colourway. Tapping a dot shows that colour; tapping the photo puts the
   colour on show into the bundle. A dot that is in the bundle keeps a ring,
   so a 3-for-55 with two Dues in it reads correctly on one card — which the
   old grid could not show at all.

   AND A CHOOSE COLOUR BUTTON, because a card asks three questions at once —
   what is this frame, what colours does it come in, and do I want it — and
   only the last of those had an obvious answer. The product page cannot be
   the answer mid-bundle: leaving the page loses the selection. So the
   button opens the quick-add drawer instead, in builder clothes: a large
   photograph, the measurements, the colours spelled out by name rather than
   as dots, and Add to bundle in place of Add to bag. Nobody leaves the page.

   THE PAGE SIZE NOW COUNTS FAMILIES, not frames. 48 families is roughly
   two hundred frames, so the first page covers far more of the range than
   48 cards ever did, at a similar rendering cost: one image per card rather
   than the whole strip.

   WHICH COLOUR A CARD SHOWS, in order: the one the shopper last tapped on
   that card, otherwise one that is already in the bundle, otherwise the
   first — which, because the view hands families over in best-selling
   order, is the family's best seller.

   GROUPING IS BY KEY, NOT BY RUN. A ?pick= link lifts one frame to the
   front of the view, and grouping consecutive cards would then have split
   its family in two — the lifted colourway alone at the top and its
   siblings further down. Keyed grouping keeps the family whole and moves
   the whole card to the front instead. */
var POOL={}, tier=null, picks=[], busy=false;
var bundleShown=48;
var famSel={}, detailKey=null;
function B(){return (DATA.bundles||{})[tier]}
function bundlePool(){var b=B(); return b?((POOL[b.collection]||[]).filter(function(p){return p.available})):[]}
function bundleView(){
  var pool=bundlePool();
  var fn = window.SF && window.SF.bundleView;
  return (typeof fn==='function') ? fn(pool) : pool;
}
/* pid -> family and the per-product facts the pool does not carry. The
   pool comes from products.json, which knows nothing about metafields, so
   the swatch, the measurements and the fit all come from here. */
var FAMIDX=null;
function famIdx(){
  if(FAMIDX) return FAMIDX;
  FAMIDX={};
  FAMS.forEach(function(f){
    (f.products||[]).forEach(function(p){
      if(p && p.pid!=null && FAMIDX[p.pid]===undefined){
        FAMIDX[p.pid]={handle:f.handle, title:f.title, hex:p.hex||'',
          size:p.size||'', fit:p.fit||''};
      }
    });
  });
  return FAMIDX;
}
/* A frame with no family in sf-data becomes a card of its own rather than
   being dropped or merged into someone else's. */
function famGroups(list){
  var idx=famIdx(), by={}, out=[];
  list.forEach(function(p){
    var m=idx[p.pid]||null;
    var key=m?m.handle:('p'+p.pid);
    var g=by[key];
    if(!g){ g=by[key]={key:key, title:(m&&m.title)||p.title, items:[]}; out.push(g) }
    g.items.push(p);
  });
  return out;
}
function groupByKey(key){
  var gs=famGroups(bundleView()), i;
  for(i=0;i<gs.length;i++) if(gs[i].key===key) return gs[i];
  return null;
}
function shownOf(g){
  var want=famSel[g.key], i;
  if(want){ for(i=0;i<g.items.length;i++) if(g.items[i].id===want) return g.items[i] }
  for(i=0;i<g.items.length;i++) if(picks.indexOf(g.items[i].id)>-1) return g.items[i];
  return g.items[0];
}
function bundleSwatch(el, ev){
  if(ev && ev.stopPropagation) ev.stopPropagation();
  var card=el.closest ? el.closest('.famcard') : null;
  if(!card) return;
  famSel[card.getAttribute('data-fam')] = +el.getAttribute('data-vid');
  renderBundles();
}
function colourName(t){
  var s=String(t||'').split('|');
  return (s.length>1 ? s[s.length-1] : s[0]).trim();
}
function hexOf(p){
  var m=famIdx()[p.pid];
  return (m&&m.hex)||tint(p.title,'#9bd1cc');
}
/* A metafield like "Square|Rectangle" is one string but several facts, and
   each has its own Arabic. Splitting them into their own elements gives
   sf-i18n a text node per word to swap; left as one string it would
   translate the first and leave the rest in English. */
function facts(s){
  var bits=String(s||'').split('|').map(function(x){return x.trim()}).filter(Boolean);
  if(!bits.length) return '';
  return bits.map(function(b){ return '<span>'+b+'</span>' }).join(' &middot; ');
}
function specRow(label, html){
  return html ? '<li><span>'+label+'</span><b>'+html+'</b></li>' : '';
}
/* The details drawer. It reuses #quick rather than adding a second drawer,
   so the swatch row, the footer button and their Arabic all come for free —
   see sf-drawers.

   IT IS A SPEC LIST, NOT A WRITTEN DESCRIPTION. A sentence assembled from
   metafields — "a square full-rim frame in acetate" — reads well in English
   and cannot be translated: sf-i18n swaps words, not grammar, so the Arabic
   would come out as an English sentence with Arabic nouns in it. A labelled
   list says the same things and each value translates on its own.

   Rows with nothing in them are left out rather than printed empty. Four
   families have no measurements anywhere, so that is not a rare case. */
function renderDetails(){
  var g=groupByKey(detailKey); if(!g) return;
  var sel=shownOf(g);
  var fam=famBy(g.key)||{};
  var spec=famIdx()[sel.pid]||{};
  var alt=String(sel.title||'').split('"').join('');
  var t=$('qTitle'); if(t) t.textContent=g.title;
  var body=$('qBody');
  if(body) body.innerHTML=
    '<div class="qhero"><img src="'+(sel.img||'')+'" alt="'+alt+'"></div>'+
    '<div class="swrow" id="qSw" style="margin-top:16px">'+
    g.items.map(function(p){
      return '<button aria-pressed="'+(p.id===sel.id)+'" data-vid="'+p.id+'"'+
        ' onclick="SF.bundleDetailPick('+p.id+')">'+
        '<img src="'+(p.img||'')+'" alt=""><em>'+colourName(p.title)+'</em></button>';
    }).join('')+'</div>'+
    '<p class="pmeta">'+colourName(sel.title)+' &middot; '+money(sel.price)+
    (g.items.length>1?' &middot; '+g.items.length+' colours':'')+'</p>'+
    '<ul class="qspec">'+
      specRow('Size', spec.size ? '<span class="mono">'+spec.size+'</span>' : '')+
      specRow('Fit', facts(spec.fit))+
      specRow('Shape', facts(fam.shape))+
      specRow('Material', facts(fam.material))+
      specRow('Rim style', facts(fam.tech))+
      specRow('Category', facts(fam.types))+
    '</ul>';
  var add=$('qAdd');
  if(add){
    var on=picks.indexOf(sel.id)>-1;
    add.textContent = on ? 'Remove from bundle' : 'Add to bundle';
    add.disabled=false;
    add.removeAttribute('aria-disabled');
    add.onclick=function(){ togglePick(sel.id); renderDetails() };
  }
  /* No link out. Everything the product page would have said is above, and
     following a link mid-bundle loses the selection. */
  var view=$('qView');
  if(view) view.style.display='none';
}
function bundleDetails(key, ev){
  if(ev && ev.stopPropagation) ev.stopPropagation();
  if(!groupByKey(key)) return;
  detailKey=key;
  renderDetails();
  open_('quick');
}
/* Choosing a colour inside the drawer moves the card behind it too, so
   closing the drawer never reveals a different frame than the one just
   looked at. */
function bundleDetailPick(id){
  if(!detailKey) return;
  famSel[detailKey]=id;
  renderBundles();
  renderDetails();
}
function loadPool(handle){
if(POOL[handle]) return Promise.resolve(POOL[handle]);
if(typeof window.SFBundlePool!=='function'){POOL[handle]=[]; return Promise.resolve([])}
busy=true; renderBundles();
return window.SFBundlePool(handle).then(function(list){
POOL[handle]=list; busy=false; renderBundles(); return list});
}
function initBundles(){
if(!$('bGrid'))return;
if(!tier) tier=Object.keys(DATA.bundles||{})[0];
renderBundles();
var b=B(); if(b) loadPool(b.collection);
}
function setTier(t){var prev=B(); tier=t; var next=B();
if(!prev||!next||prev.collection!==next.collection)picks=[]; else picks=picks.slice(0,next.need);
bundleShown=48; famSel={}; detailKey=null;
var reset = window.SF && window.SF.bundleReset;
if(typeof reset==='function') reset();
renderBundles();
if(next) loadPool(next.collection);
}
function togglePick(id){var b=B(), i=picks.indexOf(id);
if(i>-1)picks.splice(i,1); else {if(picks.length>=b.need)picks.shift(); picks.push(id)}
renderBundles()}
function showMoreBundles(){ bundleShown+=48; renderBundles() }
function slide(btn,dir,ev){
  if(typeof window.SFSlide==='function') return window.SFSlide(btn,dir,ev);
  if(ev && ev.stopPropagation) ev.stopPropagation();
  var strip=btn.parentNode.querySelector('.bstrip');
  if(strip) strip.scrollBy({left:dir*strip.clientWidth,behavior:'smooth'});
}
/* THE CARD MARKUP IS REPLACEABLE FROM OUTSIDE. Every change to how a card
   looks used to mean rewriting this file, which is forty kilobytes of
   things that have nothing to do with cards. window.SFBundleCard, if a
   later asset defines it, is handed the family and everything it needs to
   draw one, and whatever it returns is used instead. */
function famCard(g){
  var ctx={
    sel: shownOf(g),
    picked: function(id){ return picks.indexOf(id)>-1 },
    hex: hexOf,
    colourName: colourName,
    money: money,
    tick: TICK
  };
  if(typeof window.SFBundleCard==='function') return window.SFBundleCard(g, ctx);
  return defaultCard(g, ctx);
}
function defaultCard(g, ctx){
  var sel=ctx.sel, on=ctx.picked(sel.id);
  var alt=String(sel.title||'').split('"').join('');
  var dots=g.items.map(function(p){
    var t=String(p.title||'').split('"').join('');
    return '<i style="background:'+ctx.hex(p)+'" title="'+t+'" data-vid="'+p.id+'"'+
      ' data-picked="'+(ctx.picked(p.id)?1:0)+'"'+
      ' aria-pressed="'+(p.id===sel.id)+'"'+
      ' onclick="SF.bundleSwatch(this,event)"></i>';
  }).join('');
  var n=g.items.length;
  return '<article class="card pickable famcard" data-fam="'+g.key+'" data-vid="'+sel.id+
    '" data-picked="'+(on?1:0)+'">'+
    '<div class="sh bshell" style="background:var(--tile)">'+
      '<span class="pk">'+ctx.tick+'</span>'+
      '<div class="bstrip" onclick="SF.togglePick('+sel.id+')">'+
        (sel.img?'<img src="'+sel.img+'" alt="'+alt+'" loading="lazy">':'')+
      '</div>'+
      '<button class="qa" onclick="SF.bundleDetails(\''+g.key+'\',event)">Choose colour</button>'+
    '</div>'+
    '<div class="meta"><span class="nm">'+g.title+'</span>'+
    '<span class="pr mono">'+ctx.money(sel.price)+
    ' <span class="cnt">&middot; '+ctx.colourName(sel.title)+
    (n>1?' &middot; '+n+' colours':'')+'</span></span></div>'+
    '<div class="dd">'+dots+'</div></article>';
}
function renderBundles(){
var tabs=$('bTabs'); if(!tabs)return;
var bs=DATA.bundles||{};
tabs.innerHTML=Object.keys(bs).map(function(k){var b=bs[k];
return '<button class="btab" aria-pressed="'+(k===tier)+'" onclick="SF.setTier(\''+k+'\')">'+
'<b class="mono">'+b.label+'</b><span>Any '+b.need+' &middot; '+rangeOf(b)+
' frames &middot; normally '+money(b.was)+'</span></button>'}).join('');
var b=B(); if(!b)return;
var all=bundleView();
var groups=famGroups(all);
var page=groups.slice(0, bundleShown);
var pool=bundlePool();
var chosen=picks.map(function(id){return pool.filter(function(p){return p.id===id})[0]}).filter(Boolean);
$('bLine').innerHTML='<span>Pick '+b.need+' from the '+rangeOf(b)+
' range &mdash; '+(busy?'loading frames':picks.length+' of '+b.need+' selected &middot; '+
all.length+' frames in '+groups.length+' families')+
'</span>'+(picks.length?'<u onclick="SF.clearPicks()">Clear</u>':'');
$('bGrid').innerHTML = busy
? '<div class="empty" style="grid-column:1/-1"><h3>Loading the range</h3><p>Fetching every frame in this price range.</p></div>'
: (page.length?page.map(famCard).join('')
: '<div class="empty" style="grid-column:1/-1"><h3>Nothing in that mix</h3>'+
'<p>Drop a filter and the frames come back.</p></div>');
var more=$('bfMore');
if(more){
  var left=groups.length-page.length;
  more.style.display = left>0 ? '' : 'none';
  more.textContent = 'Show '+Math.min(48,left)+' more';
}
var cEl=$('bfCount');
if(cEl) cEl.textContent = page.length<groups.length
  ? page.length+' of '+groups.length+' families'
  : groups.length+(groups.length===1?' family':' families');
var full=chosen.reduce(function(s,p){return s+p.price},0);
var ready=chosen.length===b.need;
$('bSel').innerHTML='<span class="picked">'+
Array.apply(null,{length:b.need}).map(function(_,i){
return chosen[i]?'<span><img src="'+chosen[i].img+'" alt=""></span>':'<span>'+(i+1)+'</span>'}).join('')+'</span>'+
'<span style="font-size:12.5px;color:var(--mute)">'+(ready
?'<b class="mono" style="color:var(--ink);font-size:15px">'+money(b.price)+'</b> <s class="mono">'+money(full)+
'</s><span style="display:block;font-size:11px">You save '+money(full-b.price)+'</span>'
:'Choose '+(b.need-chosen.length)+' more')+'</span>'+
'<button class="btn" style="width:auto;padding:13px 26px'+(ready?'':';opacity:.4;cursor:not-allowed')+
'" onclick="SF.addBundle()">Add bundle</button>';
if(window.SFBundleTint) window.SFBundleTint.refresh();
}
function clearPicks(){picks=[];renderBundles()}
/* COMPLETING A BUNDLE OPENS THE BAG. Picking frames keeps the shopper on
   the grid — see addVariant — but this is the end of the task, not a step
   in it: the drawer is where the fixed price, the saving and the way to
   checkout are, so it is the right next screen.

   THE PICKS ARE ONLY CLEARED IF SHOPIFY ACCEPTED THE ITEMS. Before, they
   were cleared unconditionally and the toast announced a sale that might
   never have happened — which is how an add that failed left an empty bag
   and no way to see what had been chosen. On failure the selection stays
   exactly where it was, and the toast carries Shopify's own reason. */
function addBundle(){
var b=B(), pool=bundlePool();
var chosen=picks.map(function(id){return pool.filter(function(p){return p.id===id})[0]}).filter(Boolean);
if(chosen.length<b.need){toast('Pick '+(b.need-chosen.length)+' more'); return}
var gid=tier+'-'+Date.now();
var items=chosen.map(function(p){return {id:p.id,quantity:1,properties:{_bundle:b.label,_bundle_id:gid}}});
addItems(items).then(function(){
picks=[]; closeAll(); renderBundles(); openBag();
toast(b.label+' added');
}, function(err){
toast(err && err.message ? err.message : 'Could not add the bundle');
})
}
var deferred=null, forceMob=false;
window.addEventListener('beforeinstallprompt',function(e){e.preventDefault();deferred=e;
setTimeout(function(){var p=$('pwabar'); if(p)p.classList.add('on')},3000)});
function install(){var p=$('pwabar'); if(p)p.classList.remove('on');
if(deferred){deferred.prompt();deferred=null} else toast('On iPhone use Share, then Add to Home Screen')}
function syncMob(){D.body.classList.toggle('mob',forceMob||window.innerWidth<=900)}
var rt=null;
window.addEventListener('resize',function(){
syncMob();
clearTimeout(rt); rt=setTimeout(function(){
var grid=$('famGrid'); if(!grid)return;
shuffleTints(grid, wraps().filter(function(w){return w.style.display!=='none'}));
},250);
});
function toggleLang(){
var cur=(D.documentElement.lang||'en').slice(0,2);
window.location=(cur==='ar'?'/en':'/ar')+window.location.pathname}
D.addEventListener('click',function(){if(sortOpen)setSort(sortBy)});
function boot(){
syncMob();
syncCount(DATA.cart_count||0);
if($('famGrid')){fromURL();renderShop()}
if($('pdp'))initPDP();
if($('bGrid'))initBundles();
}
/* SF is published BEFORE boot runs: the bundle renderer reads it during its
   first render, and the inline handlers it writes need it immediately. */
window.SF={openBag:openBag,openMenu:openMenu,closeAll:closeAll,quick:quick,swap:swap,
addVariant:addVariant,qty:changeLine,removeBundle:removeBundle,renderBag:renderBag,
openFilters:openFilters,applyFilters:applyFilters,
clearFilters:clearFilters,tog:tog,setSort:setSort,toggleSort:toggleSort,setMax:setMax,setMin:setMin,
setTab:setTab,pick:pick,addSet:addSet,gal:gal,
setTier:setTier,togglePick:togglePick,clearPicks:clearPicks,addBundle:addBundle,
bundleSwatch:bundleSwatch,bundleDetails:bundleDetails,bundleDetailPick:bundleDetailPick,
renderBundles:renderBundles,showMoreBundles:showMoreBundles,slide:slide,
install:install,toggleLang:toggleLang,toast:toast};

if(D.readyState!=='loading')boot(); else D.addEventListener('DOMContentLoaded',boot);
})();